export default {
	language: 'العربية',  // This value is not translated as it is already in Arabic.
	banner_title: 'Enquête de Satisfaction Client',
	banner_text1: "Afin d'atteindre et de maintenir une qualité élevée des services fournis par nous, des enquêtes de satisfaction client sont envoyées périodiquement au chef de projet client et à la fin des étapes importantes.",
	banner_text2: `Ces rapports nous permettent de surveiller le travail, d'améliorer les performances de manière opportune et de mieux vous servir.`,
	banner_text3: 'Merci de prendre le temps de remplir ce formulaire.',
	projectInfo_projectName: 'Nom du projet',
	projectInfo_client: 'Client',
	projectInfo_surveyDate: 'Date de l\'enquête',
	projectInfo_projectTeamMembers: 'Membres de l\'équipe du projet',
	projectInfo_projectManager: 'Chef de projet',
	projectInfo_customerProjectManager: 'Chef de projet client',
	survey_notSatisfied: 'Pas satisfait',
	survey_satisfied: 'Complètement satisfait',
	survey_filledBy: 'Rempli par',
	survey_email: 'Email',
	survey_alreadyFilled: 'Affichage des réponses à l\'enquête.',
	survey_loading: 'Chargement de l\'enquête...',
	survey_notFound: 'L\'enquête n\'est pas valide'
};